import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import apiSortReverse from '../utils/apiSortReverse';

/**
 * A drop-in replacement for Flarum's native sort dropdown
 * Ours need to handle the special case of sort options that aren't actually visible in the dropdown itself
 */
export default class SortDropdown extends Component {
  view() {
    const sortMap = app.discussions.sortMap();
    const sortOptions = Object.keys(sortMap).reduce((acc, sortId) => {
      const sort = sortMap[sortId];
      acc[sortId] = typeof sort !== 'string' ? sort.label : app.translator.trans(`core.forum.index_sort.${sortId}_button`);
      return acc;
    }, {});
    const defaultSort = app.search.state.defaultSort();
    const activeSortFrontendKey = app.search.state.params().sort;
    let label = sortOptions[activeSortFrontendKey] || sortOptions[defaultSort];
    const mappingInExtended = app.discussions.extendedSortMap()[activeSortFrontendKey];

    // If the currently active sort is present in the extended map but not the default map, we will use a custom label
    if (mappingInExtended && app.discussions.sortValue(sortMap[activeSortFrontendKey]) !== mappingInExtended) {
      const reverse = apiSortReverse(mappingInExtended);

      // This shouldn't happen, unless you manually type a REST sort option in the URL which has neither positive or negative entry in the map
      label = 'N/A';
      for (let sortParam in sortMap) {
        if (app.discussions.sortValue(sortMap[sortParam]) === reverse) {
          label = sortOptions[sortParam];
          break;
        }
      }
      if (label === 'N/A') {
        console.warn('Could not find a label for REST sort ' + reverse);
      }
    }
    return Dropdown.component({
      buttonClassName: 'Button',
      label,
      accessibleToggleLabel: app.translator.trans('core.forum.index_sort.toggle_dropdown_accessible_label')
    }, Object.keys(sortOptions).map(value => {
      const label = sortOptions[value];
      const active = (activeSortFrontendKey || defaultSort) === value;
      return Button.component({
        icon: active ? 'fas fa-check' : true,
        onclick: () => app.search.state.changeSort(value),
        active: active
      }, label);
    }));
  }
}
flarum.reg.add('blomstra-sort-order-toggle', 'forum/components/SortDropdown', SortDropdown);